import { DatePickerInput } from "$/lib/components/molecules";
import CalendarIconV2 from "$/lib/icons/CalendarIconV2";
import ChevronIcon from "$/lib/icons/ChevronIcon";
import type { ThemeChoices } from "$/lib/types/General.types";
import { cn } from "$/lib/utils/functions/misc.functions";
import { customColors } from "tailwind.config";

type Props = {
  theme: ThemeChoices;
  selectedDate: Date;
  setSelectedDate: (date: Date) => void;
};

const MarketMonitoringDatePicker = ({
  theme,
  selectedDate,
  setSelectedDate,
}: Props) => {
  return (
    <DatePickerInput
      selected={selectedDate}
      onChange={(value) => value && setSelectedDate(value)}
      className={cn("rounded-full bg-white px-4 py-2 text-sm font-medium", {
        "text-secondary": theme === "blue",
        "text-forest": theme === "green",
        "text-warning": theme === "orange",
      })}
      calendarIcon={
        <CalendarIconV2
          fill={
            theme === "blue"
              ? customColors.secondary.DEFAULT
              : theme === "green"
                ? customColors.forest.DEFAULT
                : customColors.warning.DEFAULT
          }
        />
      }
      customInputRightComponent={
        <ChevronIcon
          fill={
            theme === "blue"
              ? customColors.secondary.DEFAULT
              : theme === "green"
                ? customColors.forest.DEFAULT
                : customColors.warning.DEFAULT
          }
          className="rotate-90"
        />
      }
      theme={theme}
    />
  );
};

export default MarketMonitoringDatePicker;
